import axios from "axios";

// Actions
export const VALIDATE_REQUEST = "merge/VALIDATE_REQUEST";
export const VALIDATE_SUCCESS = "merge/VALIDATE_SUCCESS";
export const VALIDATE_FAILURE = "merge/VALIDATE_FAILURE";
export const HAS_SOURCE_ACCOUNT_INFO = "merge/HAS_SOURCE_ACCOUNT_INFO";
export const RESET_VALIDATION_STATE = "merge/RESET_VALIDATION_STATE";

// Reducer
const initialState = {
  loading: false,
  error: null,
  data: null,
  hasSourceAccountInfo: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case VALIDATE_REQUEST:
      return { ...state, error: null, loading: true };
    case VALIDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.payload
      };
    case VALIDATE_FAILURE:
      return {
        ...state,
        loading: false,
        ...action.payload
      };
    case HAS_SOURCE_ACCOUNT_INFO:
      return { ...state, hasSourceAccountInfo: action.payload };
    case RESET_VALIDATION_STATE:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

// Action Creators
export const setHasSourceAccountInfo = bool => ({
  type: HAS_SOURCE_ACCOUNT_INFO,
  payload: bool
});

export const validateRequest = () => ({
  type: VALIDATE_REQUEST
});

export const validateSuccess = data => ({
  type: VALIDATE_SUCCESS,
  payload: data
});

export const validateFailure = (error, data) => {
  const payload = { error };
  if (data) {
    payload.data = data;
  }
  return {
    type: VALIDATE_FAILURE,
    payload
  };
};

export const resetValidationState = () => ({
  type: RESET_VALIDATION_STATE
});

/**
 * Initiates the merge validation of a source account into a target account.
 * All information pertaining to the merge validation is contained in cookies and
 * headers provided by gateway.
 */
export const validate = () => async (dispatch, getState) => {
  const {
    paths: { api }
  } = getState();
  dispatch(validateRequest());
  try {
    const { data } = await axios.post(`${api}/merge/validate`);
    dispatch(validateSuccess(data));
  } catch (error) {
    /**
     * The shape of the response from PUAMerge is very peculiar and the edge does not reformat
     * it to abide by api standards.  As a result, the data is found nestled down within a non
     * standard location.  PUAMerge API will need revised for this to abide by standards.
     */
    let data = null || error.response?.data?.message;
    dispatch(validateFailure(error, data));
  }
};

// Selectors

export const getHasSourceAccountInfo = state =>
  state.merge.validate.hasSourceAccountInfo;

export const getMergeValidateErrors = state =>
  state.merge.validate.data?.errors;

export const getMergeValidateWarnings = state =>
  state.merge.validate.data?.warnings;

export const getSourceUsername = state =>
  state.merge.validate.data?.sourceUserId;

export const getSourceAccountPuaId = state =>
  state.merge.validate.data?.sourceUserPuaId;

export const getSourceUserMetadata = state =>
  state.merge.validate.data?.sourceUserPersonalizedContent;

export const getTargetUserMetadata = state =>
  state.merge.validate.data?.targetUserPersonalizedContent;

export const getMergeValidateLoading = state => state.merge.validate.loading;

export const getMergeValidateError = state => state.merge.validate.error;
